export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/location.37941452-30777e.png";